<template>
  <MenuList class="w-[280px]">
    <MenuListItem icon="Delete" @click="handleDeleteClick">
      Delete
    </MenuListItem>
    <MenuListItem v-if="hasOneItem" icon="Rename" @click="handleRenameClick">
      Rename
    </MenuListItem>
    <MenuListItem icon="Move" @click="handleMoveClick"> Move </MenuListItem>
  </MenuList>
</template>

<script setup lang="ts">
import { useDialog } from '@/shared/dialogs/useDialog'
import { Dialogs } from '@/shared/dialogs/types'
import type { Item } from '@/shared/graphql/router/graphql'
import { computed } from 'vue'
import { MenuList, MenuListItem } from '@/shared/components/Menu'

const props = defineProps<{
  items: Item[]
}>()
const emit = defineEmits<{
  clicked: []
}>()

const { open } = useDialog()

const hasOneItem = computed(() => props.items.length === 1)

const handleDeleteClick = () => {
  open(Dialogs.DeleteFolders, {
    props: { items: props.items },
  })
  emit('clicked')
}

const handleMoveClick = () => {
  document.body.click()

  open(Dialogs.MoveItems, {
    props: { ids: props.items.map((item) => item.id) },
  })
  emit('clicked')
}

const handleRenameClick = () => {
  open(Dialogs.RenameFolder, {
    props: { item: props.items[0] },
  })
  emit('clicked')
}
</script>
